module.exports = __webpack_public_path__ + "assets/img/HDB_Plantation District Lake_RGB_lr.e4bda97b.jpg";